module.exports = __webpack_public_path__ + "img/bee005.95d56e09.svg";